import { Binder } from '@ribajs/core'
import { CountryProvinceSelector } from '../utils/index.js'

/**
 * This binder binds the country select to the province select
 */
export class CountrySelectsBinder extends Binder<
  { default: string; formId: number },
  HTMLSelectElement
> {
  static key = 'country-selects'

  /** This method is called every time the attribute values changes */
  routine(el: HTMLSelectElement, data: { default: string; formId: number }) {
    new CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew',
    })

    new CountryProvinceSelector(el, `AddressProvince_${data.formId}`, {
      hideElement: `AddressProvinceContainer_${data.formId}`,
    })
  }
}
